import { render, staticRenderFns } from "./kia.vue?vue&type=template&id=7f8d12a6&scoped=true&"
import script from "./kia.vue?vue&type=script&lang=js&"
export * from "./kia.vue?vue&type=script&lang=js&"
import style0 from "./kia.vue?vue&type=style&index=0&id=7f8d12a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8d12a6",
  null
  
)

export default component.exports